import { useState } from "react";
import { SalesHeadlineForm } from "@/features/tools/SalesHeadlineForm";
import { SalesHeadlineResult } from "@/features/tools/SalesHeadlineResult";
import { ToolPageLayout } from "@/features/tools/ToolPageLayout";
import { runSalesHeadlineGenerator } from "@/features/tools/proToolApi";
import { toolPageMetadata } from "@/features/tools/toolMetadata";
import { useProToolPageData } from "@/features/tools/useProToolPageData";
import type {
  SalesHeadlineOutput,
  SalesHeadlineRequest,
} from "@/features/tools/proToolTypes";

const metadata = toolPageMetadata.sales_page_headline_generator;

export function SalesHeadlineToolPage() {
  const {
    canUseProTools,
    results,
    projects,
    generatedBlueprints,
    isLoading,
    error,
    getToken,
    refreshResults,
  } = useProToolPageData();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [latestResult, setLatestResult] = useState<SalesHeadlineOutput | null>(
    null,
  );
  const [toolError, setToolError] = useState<string | null>(null);

  async function handleSubmit(input: SalesHeadlineRequest) {
    setIsSubmitting(true);
    setToolError(null);

    try {
      const token = await getToken();
      const response = await runSalesHeadlineGenerator(token, input);
      setLatestResult(response.result.output_payload as SalesHeadlineOutput);
      await refreshResults();
    } catch {
      setToolError("We could not generate this right now. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <ToolPageLayout
      title={metadata.title}
      label={metadata.label}
      intro={metadata.intro}
      canUseProTools={canUseProTools}
      isLoading={isLoading}
      error={error}
      results={results}
      toolType={metadata.toolType}
      emptyResultsMessage={metadata.emptyResultsMessage}
    >
      <SalesHeadlineForm
        projects={projects}
        generatedBlueprints={generatedBlueprints}
        isSubmitting={isSubmitting}
        error={toolError}
        onSubmit={(input) => void handleSubmit(input)}
      />

      {latestResult ? <SalesHeadlineResult output={latestResult} /> : null}
    </ToolPageLayout>
  );
}
